export default __webpack_public_path__ + "static/media/logSaw.e83f1e4b.png";